module.exports = __webpack_public_path__ + "static/media/pic1.b0c221c8.jpeg";